import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { updateProfile, onAuthStateChanged } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { prepararFotoPerfil } from '../../../core/media/prepararFotoPerfil.js';

function esperarAuthInicializado(auth) {
  return new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, () => {
      unsub();
      resolve();
    });
  });
}

/**
 * Sube la foto a Storage (`usuarios/{uid}/perfil.webp`) y actualiza `photoURL` en Firebase Auth.
 */
export async function subirFotoPerfilUsuario({ getFirebase, file }) {
  const { auth, storage, db } = getFirebase();
  await esperarAuthInicializado(auth);
  const user = auth.currentUser;
  if (!user) throw new Error('No hay sesión activa.');
  await user.getIdToken(true);
  const prepared = await prepararFotoPerfil(file);
  const path = `usuarios/${user.uid}/perfil.webp`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, prepared, { contentType: 'image/webp' });
  const url = await getDownloadURL(storageRef);
  await updateProfile(user, { photoURL: url });
  if (db) {
    await setDoc(
      doc(db, 'usuarios', user.uid),
      { foto_url: url, actualizadoEn: serverTimestamp() },
      { merge: true }
    );
  }
  return url;
}
